module.exports = __webpack_public_path__ + "static/media/Discord.b79c909e.svg";